import { useState } from "react";
import Header from "@/components/Header";
import RoadmapGrid from "@/components/roadmap/RoadmapGrid";
import { categories } from "@/data/categories";
import { initialTodos } from "@/data/todos";

const Todo = () => {
  const [todos] = useState(initialTodos);

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="container mx-auto px-4 pt-24 pb-16">
        <h1 className="text-3xl font-bold mb-8">Development Roadmap</h1>
        <RoadmapGrid categories={categories} todos={todos} />
      </main>
    </div>
  );
};

export default Todo;